export default "__VITE_ASSET__BJT33$Nm__"